import { createPrefixedActions } from '@zapier/toolbox-redux-framework/src/redux-utils';

export default createPrefixedActions(
  'error',
  `
    ADD_ERROR
    CLEAR_ERROR
    CLEAR_ERRORS
  `
);
